// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_1LNA_PjKiBUX7jcG7YoE4l"};